import { FC, Fragment } from 'react';
import { RefinementListRow } from '~/features/productList/components/RefinementListRow';
import SwitchElement from '~/shared/components/form/components/controllable-elements/switch-element';
import { useTranslation } from '~/shared/utils/translation';
import { useSalesOfferGroups } from '~/features/productList/hooks/useSalesOfferGroups';
import styles from './RefinementSalesOffersList.module.scss';

/**
 * Mobile equivalent of the desktop RefinementSalesOffersDropdown — same 5 grouped categories
 * (via useSalesOfferGroups), embedded directly in FilterDrawer's shared detail view rather than
 * its own dropdown. Per Figma, mobile omits the per-row and "all" product counts that desktop
 * shows.
 */
export const RefinementSalesOffersList: FC = () => {
    const { translate } = useTranslation();
    const { groupItems, isAllRefined, handleGroupRefine, handleAllRefine, handleSubItemRefine } =
        useSalesOfferGroups();

    return (
        <div className={styles.panel}>
            <p className={styles.disclaimer}>{translate('plp.salesOffers.disclaimer')}</p>

            <div className={styles.allRow}>
                <SwitchElement
                    checked={isAllRefined}
                    onChange={handleAllRefine}
                    label={translate('plp.salesOffers.allToggle')}
                />
            </div>

            {groupItems.map((item) => (
                <Fragment key={item.key}>
                    <RefinementListRow
                        label={item.label}
                        value={item.key}
                        isRefined={item.isRefined}
                        isIndeterminate={item.isIndeterminate}
                        isDisabled={item.count === 0 && !item.isRefined && !item.isIndeterminate}
                        onRefine={handleGroupRefine}
                    />

                    {item.subItems.some((subItem) => subItem.isRefined) &&
                        item.subItems.map((subItem) => (
                            <RefinementListRow
                                key={subItem.key}
                                label={subItem.label}
                                value={subItem.value}
                                count={subItem.count}
                                isRefined={subItem.isRefined}
                                isSubItem
                                isDisabled={subItem.count === 0 && !subItem.isRefined}
                                shouldShowCount
                                onRefine={handleSubItemRefine}
                            />
                        ))}
                </Fragment>
            ))}
        </div>
    );
};

export default RefinementSalesOffersList;
